import { OnFieldChanged } from '../../../../../../shared/modules/configurable-form/models/on-field-changed';
import { Store } from '@ngrx/store';

import { Injectable } from '@angular/core';
import { getJobsiteSelected, OrderBuilderState } from '../../../../../reducers';
import * as fromExperiencesActions from '@ordersnproducts/modules/order-builder/modules/location/actions/experiences-actions/experiences.actions';
import { COUNTRY_CODE, ILegalEntity, IShipmentLocation } from '@cemex-core/cmx-api';
import { filter, take } from 'rxjs/operators';
import { getLegalEntity } from '@cemex/cmx-client-layout';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { SetExperience } from '@ordersnproducts/modules/order-builder/modules/location/actions/experiences-actions/experiences.actions';

@Injectable()
export class ExperiencesDefaultCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) { }

  onFieldChanged(value: number): void {
    this.store
      .select(getJobsiteSelected)
      .pipe(
        filter(jobsite => !!value && !!jobsite),
        take(1),
      )
      .subscribe((jobsite: IShipmentLocation) => this.store.dispatch(new fromExperiencesActions.FetchFailure()));
  }
}

@Injectable()
export class SimmaOnlineDefaultCommand implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) { }

  onFieldChanged(value: number): void {
    this.store
      .select(getLegalEntity)
      .pipe(
        filter(jobsite => !!value && !!jobsite),
        take(1),
      )
      .subscribe((customer: ILegalEntity) => {
        const experience = customer.countryCode.trim() === COUNTRY_CODE.ISRAEL
          ? ORDER_EXPERIENCES.SIMMA_UNIVERSAL_LINK
          : null;
        this.store.dispatch(new SetExperience({
          experienceCode: experience,
          _links: [],
          experienceId: 0,
          isOnline: 0,
          features: [
            { key: 'ValueAddedSpecialized', enabled: false }],
        }));
      });
  }
}
